export const formatRanges = (ranges) => {
  return ranges.map((range, index, arr) => {
    const [min, max] = range.split("-").map((val) => val.replace(/,/g, ""));

    let previousMax = null;
    if (index > 0) {
      const prevRange = arr[index - 1]
        .split("-")
        .map((val) => val.replace(/,/g, ""));
      previousMax = prevRange[1] ?? prevRange[0];
    }

    // Adjust min value dynamically (e.g., 101 → 100, 501 → 500, etc.)
    const adjustedMin =
      previousMax && parseInt(min) === parseInt(previousMax) + 1
        ? `${parseInt(previousMax)}`
        : min;

    // Ensure no duplicate `+` at the end
    const formattedKey = max
      ? `${adjustedMin.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}-${max.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ","
        )}`
      : adjustedMin.endsWith("+")
      ? adjustedMin.replace(/\B(?=(\d{3})+(?!\d))/g, ",") // Avoid adding extra `+`
      : `${adjustedMin.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}+`;

    return {
      key: formattedKey,
      value: range,
    };
  });
};

export const parseDate = (dateString) => {
  if (!dateString || typeof dateString !== "string") {
    return new Date(0);
  }
  const parts = dateString.split("/").map(Number);
  if (parts.length !== 3) {
    return new Date(0);
  }
  const [day, month, year] = parts;
  return new Date(year, month - 1, day);
};

// export const formatPrice = (value) => {
//   if (value == null) return null;
//   const raw = value.toString().replace(/[£$€₪]/g, "");
//   const num = parseFloat(raw);
//   if (!isNaN(num) && isFinite(num)) {
//     return Number.isInteger(num) ? num : num.toFixed(2);
//   }
//   return null;
// };

export const formatPrice = (value) => {
  if (value == null) return null;
  const raw = value.toString().replace(/[£$€₪]/g, "");
  const num = parseFloat(raw);
  if (!isNaN(num) && isFinite(num)) {
    if (Number.isInteger(num) || num.toString().split(".")[1]?.length <= 1) {
      return num.toString();
    }
    return num.toFixed(2);
  }
  return null;
};
